
export const testimonialData = [
  {
    id: '1',
    name: 'Sarah Johnson',
    location: 'Mumbai, India',
    rating: 5,
    text: 'The therapy sessions completely transformed my approach to managing anxiety. I feel more confident and peaceful than ever before.',
    date: '3 weeks ago',
    imageUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  },
  {
    id: '2',
    name: 'Rajesh Kumar',
    location: 'Bangalore, India',
    rating: 5,
    text: 'iFindLife helped me through a difficult period in my life. The support and guidance I received was invaluable.',
    date: '1 month ago',
    imageUrl: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  },
  {
    id: '3',
    name: 'Priya Patel',
    location: 'Delhi, India',
    rating: 4,
    text: 'The mindfulness programs helped me find balance in my hectic life. Highly recommend to anyone seeking inner peace.',
    date: '2 weeks ago',
    imageUrl: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  },
  {
    id: '4',
    name: 'Vikram Singh',
    location: 'Chennai, India',
    rating: 5,
    text: 'Professional, caring, and effective. The team at iFindLife truly understands mental wellness.',
    date: '1 week ago',
    imageUrl: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=256&q=80'
  }
];
